import { InvalidTimestampFormatError } from '../../errors';

/**
 * Returns a formatted epoch timestamp as mm/dd/yy.
 * @param {Number} timestamp - The epoch time to format in milliseconds (ms)
 */
const formatDate = timestamp => {
  if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
    throw new InvalidTimestampFormatError();
  }
  const ts = timestamp;
  const date = new Date(ts);
  const dd = date.getDate();
  const mm = date.getMonth() + 1;
  const yy = date.getFullYear();
  return `${mm}/${dd}/${yy}`;
};

export default formatDate;
